import { render, staticRenderFns } from "./Newsfeed.vue?vue&type=template&id=6a82c33e&scoped=true"
import script from "./Newsfeed.vue?vue&type=script&lang=js"
export * from "./Newsfeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a82c33e",
  null
  
)

export default component.exports